export default /* glsl */`
    visMode = outLife < 0.0? -1.0: visMode;
`;
